import {useEffect, useRef} from "react";

const ErrorDisplay = (props) => {
  const { errors, id, shouldFocus } = props;
  const errorRef = useRef(null);

  useEffect(() => {
    if (shouldFocus) {
      errorRef.current?.focus();
    }
  }, [errors, shouldFocus]);


  return (
    <ul className='error-display' id={id} ref={errorRef} tabIndex='-1'>
      { errors.map((error, idx) => (
        <li className='error-text' key={error}>
          <span className='sr-hide'>Error: </span>
          {error}
        </li>
      ))}
    </ul>
  );
};

export default ErrorDisplay;